import WebBluetoothClient from './web_bluetooth_client';
import WebBluetoothBleClient from './web_bluetooth_blu_client';
import WebBluetoothRpcClient from './web_bluetooth_rpc_client';
import WebBluetoothEvents from './web_bluetooth_events';

export default class WebBluetoothService extends EventTarget {
	private readonly BLU_DEVICES =
		/^(SBDI|SBBT|SBDW|SBHT|SBMO|SBDS|SBWS|SBRC|SBRK|SBSM|SMSN|SBMS|SBSN)-\w|^BLU\s/;

	/**
	 * Static variable to check if Bluetooth is supported by the browser
	 */
	public static isSupported: boolean = navigator.bluetooth != null;

	/**
	 * Start scanning for BLE devices.
	 */
	public async startScan(namePrefix = ''): Promise<WebBluetoothClient> {
		let webBleClient: WebBluetoothClient;
		const filters = [];
		if (namePrefix) {
			const namePrefixSplit = namePrefix.split('|');
			for (let i = 0; i < namePrefixSplit.length; ++i) {
				filters.push({ namePrefix: namePrefixSplit[i] });
			}
		} else {
			filters.push({
				manufacturerData: [
					{
						companyIdentifier: 0x0ba9,
					},
				],
			});
		}
		try {
			const connectedDevice: BluetoothDevice = await navigator.bluetooth.requestDevice({
				filters,
				optionalServices: [
					WebBluetoothRpcClient.DEVICE_SERVICE_UUID,
					WebBluetoothBleClient.DEVICE_SERVICE_UUID,
				],
			});
			if (this.BLU_DEVICES.test(connectedDevice.name)) {
				webBleClient = new WebBluetoothBleClient(connectedDevice);
				this.dispatchEvent(new CustomEvent(WebBluetoothEvents.BLE_PAIR_REQUIRED));
			} else {
				webBleClient = new WebBluetoothRpcClient(connectedDevice);
			}
		} catch (error) {
			this.dispatchEvent(new CustomEvent(WebBluetoothEvents.CLOSED));
		}
		return webBleClient;
	}
}
